/**
 * Страница удаления аккаунта (URL для Google Play Data safety).
 * Должна содержать: название как в сторе, пошаговые инструкции, что удаляется/остаётся, сроки.
 */

const CONTACT_EMAIL = 'ma.fazylova@gmail.com';
const LAST_UPDATED = '01.03.2026';

export const ACCOUNT_DELETION_RU = {
  'accountDeletion.title': 'Удаление аккаунта и данных',
  'accountDeletion.lastUpdated': `Последнее обновление: ${LAST_UPDATED}`,
  'accountDeletion.heroNote':
    'Приложение в Google Play может быть указано как MadTraining; сервис для тренеров — MadCoach. Запрос на удаление относится к одной учётной записи этого сервиса.',
  'accountDeletion.intro':
    'Ниже — как запросить удаление вашего аккаунта и связанных персональных данных. После выполнения запроса вы не сможете войти под этими данными без новой регистрации.',

  'accountDeletion.stepsTitle': 'Как запросить удаление аккаунта',
  'accountDeletion.step1':
    'Войдите в приложение MadCoach (веб или Android): используйте email и пароль, Google, Apple или Telegram — тот способ входа, с которым у вас привязан аккаунт.',
  'accountDeletion.step2':
    'Откройте вкладку «Профиль».',
  'accountDeletion.step3':
    'Прокрутите экран профиля вниз до кнопки удаления аккаунта («Удалить профиль» / аналог), нажмите её и подтвердите удаление во всплывающем диалоге.',
  'accountDeletion.step4':
    `Если удалить аккаунт через приложение невозможно (нет доступа к входу или ошибка сети), напишите на ${CONTACT_EMAIL} с адреса электронной почты, указанного в вашей учётной записи. В теме или тексте сообщения укажите: прошу удалить мой аккаунт MadCoach/MadTraining и связанные персональные данные. Мы можем запросить дополнительные данные для подтверждения вашей личности.`,

  'accountDeletion.dataTitle': 'Какие данные удаляются',
  'accountDeletion.dataBody':
    `Обычно удаляются или обезличиваются привязанные к вашему аккаунту персональные данные, включая: данные профиля, сохранённые вами сведения о тренировках, клиентах, расписании, учёте оплат и заметках, а также технические связки, позволявшие восстановить связь между записями и вашим аккаунтом.\nКонкретный объём соответствует тому, что вы сохраняли в сервисе.`,

  'accountDeletion.retentionTitle': 'Что может сохраниться и как долго',
  'accountDeletion.retentionBody':
    `После подтверждения вашей личности мы удалим персональные данные или обезличим их в разумный срок, как правило до 30 календарных дней. Более длинный период возможен только если это объективно нужно для резервных технических копий или если применимое законодательство требует хранить отдельные сведения (например, обязательные учётные или налоговые записи).\nРезервные копии инфраструктуры могут содержать остаточные технические записи ограниченное время с ограниченным доступом.`,

  'accountDeletion.contactTitle': 'Контакт',
  'accountDeletion.contactBody':
    `Вопросы по удалению данных: ${CONTACT_EMAIL}.\nПолную политику конфиденциальности см. на странице «Политика конфиденциальности» на этом сайте (${CONTACT_EMAIL} также указан там).`,
  'accountDeletion.back': 'Назад',
  'accountDeletion.linkPrivacy': 'Политика конфиденциальности',
};

export const ACCOUNT_DELETION_EN = {
  'accountDeletion.title': 'Account and data deletion',
  'accountDeletion.lastUpdated': `Last updated: ${LAST_UPDATED}`,
  'accountDeletion.heroNote':
    'The app on Google Play may be listed as MadTraining; the coach service brand is MadCoach. A deletion request applies to one account with this service.',
  'accountDeletion.intro':
    'Below is how to request deletion of your account and associated personal data. After deletion you will not be able to sign in with the same credentials without registering again.',

  'accountDeletion.stepsTitle': 'How to request account deletion',
  'accountDeletion.step1':
    'Sign in to MadCoach (web or Android) using email and password, Google, Apple or Telegram—the method linked to your account.',
  'accountDeletion.step2':
    'Open the Profile tab.',
  'accountDeletion.step3':
    'Scroll down to the destructive account deletion control (labelled like «Delete profile» or similar), tap it and confirm in the dialog.',
  'accountDeletion.step4':
    `If you cannot delete in-app (no access or errors), email ${CONTACT_EMAIL} from the address registered on your account. Ask to delete your MadCoach/MadTraining account and related personal data. We may ask for extra information to verify your identity.`,

  'accountDeletion.dataTitle': 'What data is deleted',
  'accountDeletion.dataBody':
    `We normally delete or anonymise personal data tied to your account, including profile data and content you saved (training records, clients, schedule, payments/notes where applicable), and technical links that associated those records with your account.\nThe exact scope matches what you stored in the Service.`,

  'accountDeletion.retentionTitle': 'What may be kept and for how long',
  'accountDeletion.retentionBody':
    `After we verify your identity we delete or anonymise personal data within a reasonable period, usually within 30 calendar days. A longer period applies only where objectively needed for technical backups or where law requires retaining certain records.\nInfrastructure backups may hold residual fragments for a limited time with restricted access.`,

  'accountDeletion.contactTitle': 'Contact',
  'accountDeletion.contactBody':
    `Deletion questions: ${CONTACT_EMAIL}.\nSee our full Privacy Policy on this site (contact details are repeated there).`,
  'accountDeletion.back': 'Back',
  'accountDeletion.linkPrivacy': 'Privacy Policy',
};

export const ACCOUNT_DELETION_ES = {
  'accountDeletion.title': 'Eliminación de cuenta y datos',
  'accountDeletion.lastUpdated': `Última actualización: ${LAST_UPDATED}`,
  'accountDeletion.heroNote':
    'La app puede publicarse como MadTraining; la marca del servicio para entrenadores es MadCoach. La solicitud afecta una sola cuenta de este servicio.',
  'accountDeletion.intro':
    'Aquí puedes solicitar borrar tu cuenta y los datos personales asociados. Tras el borrado no podrás iniciar sesión con esas mismas credenciales salvo registrarte de nuevo.',

  'accountDeletion.stepsTitle': 'Cómo solicitar la eliminación de la cuenta',
  'accountDeletion.step1':
    'Inicia sesión en MadCoach (web o Android) con correo y contraseña, Google, Apple o Telegram según tu cuenta.',
  'accountDeletion.step2':
    'Abre la pestaña Perfil.',
  'accountDeletion.step3':
    'Desplázate hasta el control destructivo para eliminar la cuenta (algo como «Eliminar perfil»), actívalo y confírmalo en el diálogo.',
  'accountDeletion.step4':
    `Si no puedes borrar la cuenta desde la app (sin acceso u otro problema), envía correo desde la dirección de tu cuenta a ${CONTACT_EMAIL} pidiendo eliminar tu cuenta MadCoach/MadTraining y los datos relacionados. Podemos pedir información adicional para verificar tu identidad.`,

  'accountDeletion.dataTitle': 'Qué datos se eliminan',
  'accountDeletion.dataBody':
    `Normalmente borramos o anonimizamos los datos personales vinculados a tu cuenta, incluidos perfil, entrenos, agenda, registros económicos y notas que hubieras guardado, así como enlaces que asociaban esas piezas con tu cuenta.\nEl alcance concreto depende de lo que guardaste en el Servicio.`,

  'accountDeletion.retentionTitle': 'Qué puede conservarse y cuánto tiempo',
  'accountDeletion.retentionBody':
    `Tras verificar tu identidad eliminamos o anonimizamos los datos personales en un plazo razonable, habitualmente hasta 30 días naturales, salvo cuando por copias de seguridad o imperativo legal deba mantenerse algo más tiempo.\nLas copias del sistema pueden contener fragmentos residuales un tiempo técnico limitado con acceso restringido.`,

  'accountDeletion.contactTitle': 'Contacto',
  'accountDeletion.contactBody':
    `Dudas sobre eliminación: ${CONTACT_EMAIL}.\nLa política de privacidad completa está disponible en este sitio.`,
  'accountDeletion.back': 'Atrás',
  'accountDeletion.linkPrivacy': 'Política de privacidad',
};
